<template>
  <div class="flex flex-wrap items-center gap-1">
    <span
      v-if="membersPrefixText && filteredUserIds.length > 0"
      class="text-sm text-text-default"
      >{{ membersPrefixText }}</span
    >
    <div
      v-for="(userId, index) in filteredUserIds"
      :key="userId"
      class="flex items-center"
    >
      <UserBadge :user-id="userId" />
      <span
        v-if="index < filteredUserIds.length - 2"
        class="user-separator"
        >,</span
      >
      <span
        v-else-if="index === filteredUserIds.length - 2 && filteredUserIds.length > 1"
        class="user-separator ml-1"
        >{{ translate('and') }}</span
      >
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import UserBadge from '@/components/widgets/UserBadge';
import useTranslate from '@/utilities/composables/useTranslate';
import useSuggestedActions from '@/utilities/composables/useSuggestedActions';
import { useStore } from 'vuex';

const { actionTypeDefinitions } = useSuggestedActions();
const { translate } = useTranslate();
const props = defineProps({
  userIds: {
    type: Array,
    required: true,
    default: () => [],
  },
  actionType: {
    type: String,
    required: true,
  },
});

const store = useStore();

const filteredUserIds = computed(() => {
  return props.userIds.filter((userId) => {
    // user should exist in teamMembers getMemberById
    const member = store.getters.getMemberById(userId);
    return Object.keys(member).length > 0;
  });
});

const membersPrefixText = computed(() => {
  const key = actionTypeDefinitions[props.actionType]?.prefixTitle || '';
  return translate(key);
});
</script>

<style lang="scss">
.user-separator {
  @apply text-sm text-text-default;
}
</style>
